import basicMessage from "../message/Basic.svelte";
import basicForm from "../form/Basic.svelte";
export default {
    messageSelector: (message) => {
        return basicMessage;
    },
    formSelector: (message) => {
        return basicForm;
    },
    editable: (message) => {
        // TODO
        return true;
    }
};
